import React, { Component } from 'react';
import { init } from './../casino/allgames.js';

class AllGames extends Component {
	componentWillMount() {
		init();
	}

	componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	}

	render() {
		return <div id="all-games" />;
	}
}

export default AllGames;




// WEBPACK FOOTER //
// ./mobile-core/src/components/all-games.js